import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { BusinessAreaViewComponent } from '@fi-app/business-area/business-area-view/business-area-view.component';
import { BusinessAreaService } from '@fi-app/business-area/business-area.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiBusinessAreaViewState: Ng2StateDeclaration = {
    name: FiStateNames.BusinessArea.View,
    url: '/:Id',
    views: {
        '@': {
            component: BusinessAreaViewComponent,
        },
    },
    resolve: {
        businessArea: [BusinessAreaService, FiStateService, Transition, FiBusinessAreaViewStateResolve_businessArea],
        pageTitle: [PageTitleService, 'businessArea', FiBusinessAreaViewStateResolve_pageTitle],
    },
};

export function FiBusinessAreaViewStateResolve_businessArea(
    businessAreaService: BusinessAreaService,
    fiStateService: FiStateService,
    $transition$: Transition,
) {
    return businessAreaService.GetBusinessArea(fiStateService.getParams($transition$).Id);
}

export function FiBusinessAreaViewStateResolve_pageTitle(ccmPageTitle: PageTitleService, businessArea) {
    return ccmPageTitle.setTitleByItem(businessArea);
}
